export const lucky_draw_rules_en = [
  // Page 0: Game Introduction & Modes
  "Lucky Draw",
  "Random number drawing or prize lottery tool for events and games. You can conduct fair draws in two ways: Number Drawing and Prize Drawing.",
  "Number Drawing",
  "You can draw numbers from a minimum of 1 to a maximum of 9999.",
  "Prize Drawing",
  "Draw from directly added prizes. Each prize can have quantity settings and can be used for events or prize drawings.",
  "Fair Random",
  "True random algorithm ensures fair drawing, and already drawn numbers or exhausted prizes are automatically excluded.",
  "Draw History",
  "All drawing results are recorded and can be checked, and you can start over from the beginning anytime.",

  // Page 1: Usage Examples
  "Number Drawing Usage",
  "Determine order or teams in games",
  "Random assignment of presentation order",
  "Draw lottery numbers",
  "Draw bingo game numbers",
  "Prize Drawing Usage",
  "Event prize drawings",
  "Decide today's menu",
  "Assign gifts",
  "Draw team activity missions",
  "Example: Company Event Prize Drawing",
  "Register iPhone 15 (1), AirPods (3), Starbucks gift cards (10) to fairly draw 14 total prizes.",
];

export const lucky_draw_rules_ko = [
  // Page 0: 게임 소개 및 추첨
  "Lucky Draw",
  "이벤트와 게임을 위한 랜덤 숫자 또는 경품 추첨 도구입니다. 숫자 추첨과 경품 추첨 두 가지 방식으로 추첨을 진행할 수 있습니다.",
  "숫자 추첨",
  "최소 1부터 최대 9999까지의 숫자를 추첨할 수 있습니다.",
  "경품 추첨",
  "직접 추가한 경품들 중에서 추첨합니다. 각 경품마다 수량 설정이 가능하며 이벤트나 경품 추첨에 활용할 수 있습니다.",
  "공정한 랜덤",
  "진정한 랜덤 알고리즘으로 공정한 추첨을 보장하며, 이미 뽑힌 숫자나 소진된 경품은 자동으로 제외됩니다.",
  "추첨 기록",
  "모든 추첨 결과를 기록하고 확인할 수 있으며, 언제든 처음부터 다시 시작할 수 있습니다.",

  // Page 1: 활용 예시
  "숫자 추첨 활용",
  "게임에서 순서나 팀 정하기",
  "발표 순서 랜덤 배정",
  "추첨 번호 뽑기",
  "빙고 게임 숫자 추첨",
  "경품 추첨 활용",
  "이벤트 경품 추첨",
  "오늘의 메뉴 정하기",
  "선물 배정하기",
  "팀 활동 미션 뽑기",
  "예제: 회사 이벤트 경품 추첨",
  "아이폰 15 (1개), 에어팟 (3개), 스타벅스 기프티콘 (10개)을 등록하여 총 14개의 경품을 공정하게 추첨할 수 있습니다.",
];
